(() => {
  'use strict';

  let pdpLayoutFrame = 0;
  let pdpLayoutObserver = null;

  const productRoot = () => document.querySelector('[data-variant-selector]');

  const storeTriggers = () => Array.from(document.querySelectorAll('button')).filter((button) => {
    const click = String(button.getAttribute('x-on:click') || button.getAttribute('@click') || '');
    return click.includes('show-store-stock') || button.hasAttribute('data-faf-store-trigger');
  });

  const removeStockistDirections = () => {
    document.querySelectorAll('#showOptions a[href*="/pages/where-to-buy"]').forEach((link) => {
      const previous = link.previousSibling;
      if (previous?.nodeType === Node.TEXT_NODE) {
        previous.textContent = String(previous.textContent || '').replace(/\s*or your local\s*$/i, ' ');
      }
      link.remove();
    });
  };

  const syncStoreAvailabilitySurface = () => {
    if (document.querySelector('[data-faf-store-config]')) return;

    storeTriggers().forEach((trigger) => {
      trigger.hidden = true;
      trigger.disabled = true;
      trigger.tabIndex = -1;
      trigger.setAttribute('aria-hidden', 'true');
    });
  };

  const acceleratedRegions = () => [
    ...document.querySelectorAll('.shopify-payment-button'),
    ...document.querySelectorAll('#cartQuickpay')
  ];

  const syncAcceleratedCheckout = (variantId = '') => {
    if (!productRoot()) return;

    const hasSelection = Boolean(String(variantId || '').trim());

    acceleratedRegions().forEach((region) => {
      region.inert = !hasSelection;
      region.setAttribute('aria-hidden', hasSelection ? 'false' : 'true');
      region.classList.toggle('opacity-50', !hasSelection);
      region.classList.toggle('pointer-events-none', !hasSelection);
      region.classList.toggle('select-none', !hasSelection);
    });
  };

  const schedulePdpLayoutSync = () => {
    if (pdpLayoutFrame) window.cancelAnimationFrame(pdpLayoutFrame);

    pdpLayoutFrame = window.requestAnimationFrame(() => {
      pdpLayoutFrame = window.requestAnimationFrame(() => {
        pdpLayoutFrame = 0;

        window.dispatchEvent(new Event('resize'));
      });
    });
  };

  const observeNativeAtcLayout = () => {
    if (!('ResizeObserver' in window)) return;

    const region = document.querySelector('[data-native-atc-region]');
    if (!region) return;

    pdpLayoutObserver?.disconnect();
    pdpLayoutObserver = new ResizeObserver(() => schedulePdpLayoutSync());
    pdpLayoutObserver.observe(region);
  };

  const selectedVariantId = () => (
    document.querySelector('[data-variant-selector] input[type="radio"]:checked')?.value || ''
  );

  const install = () => {
    removeStockistDirections();
    syncStoreAvailabilitySurface();
    syncAcceleratedCheckout(selectedVariantId());
    observeNativeAtcLayout();
    schedulePdpLayoutSync();
  };

  window.addEventListener('variant-change', (event) => {
    syncAcceleratedCheckout(event.detail?.variantId || '');
    schedulePdpLayoutSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
})();
